module.exports = __webpack_public_path__ + "img/wrapbg7.ade582ab.png";